import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { openCalendlyPopup } from '../utils/calendly';
export function FinalCTA() {
  return <section className="py-20 bg-[#0A0E27]" data-id="element-85" data-mp="c6iw5y1c0999">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-86" data-mp="c8c0h6oh2he3">
        <div className="relative rounded-3xl overflow-hidden bg-[#141B3A] border border-[#1E293B] p-8 md:p-16 text-center" data-id="element-87" data-mp="84nqyiga5bq7">
          {/* Background Gradient */}
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-88" data-mp="m2ltmql8njpv">
            <div className="absolute top-[-50%] left-[20%] w-[600px] h-[600px] bg-[#FF5722]/10 rounded-full blur-[100px]" data-id="element-89" data-mp="h3rdxxikib9z" />
          </div>

          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-90" data-mp="qv57zprr2ivq">
            Bereit, Deinen Vertrieb zu transformieren?
          </h2>
          <p className="text-lg text-[#94A3B8] mb-10 max-w-2xl mx-auto" data-id="element-91" data-mp="14vzfm66z4ftc">
            Lass uns in einem kostenlosen Erstgespräch analysieren, wie wir Dein
            CRM-System optimieren können.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10" data-id="element-92" data-mp="2c6hkmjpbu5hw">
            <div className="flex items-center gap-2 text-[#94A3B8]" data-id="element-93" data-mp="2h3zse6rlyeob">
              <CheckCircle2 className="w-5 h-5 text-[#FF5722]" data-id="element-94" data-mp="2m1svus1j0ukw" />
              <span data-id="element-95" data-mp="2r1npv4glm0a6">Kostenlose Erstberatung (30 Min)</span>
            </div>
            <div className="hidden sm:block text-[#334155]" data-id="element-96" data-mp="2qzuj7p5zjg26">•</div>
            <div className="flex items-center gap-2 text-[#94A3B8]" data-id="element-97" data-mp="2v2r4xoqtnsac">
              <CheckCircle2 className="w-5 h-5 text-[#FF5722]" data-id="element-98" data-mp="3023tcdxcd7f1" />
              <span data-id="element-99" data-mp="30095aqqrwz6q">Konkrete Optimierungsvorschläge</span>
            </div>
            <div className="hidden sm:block text-[#334155]" data-id="element-100" data-mp="34u3wsgcmeigd">•</div>
            <div className="flex items-center gap-2 text-[#94A3B8]" data-id="element-101" data-mp="39sootshpxvtq">
              <CheckCircle2 className="w-5 h-5 text-[#FF5722]" data-id="element-102" data-mp="3erhy18pz30o3" />
              <span data-id="element-103" data-mp="3etclatopv4vc">Keine Verpflichtungen</span>
            </div>
          </div>

          <Button size="lg" className="w-full sm:w-auto text-lg px-10 py-4" rightIcon={<ArrowRight className="w-5 h-5" data-id="element-105" data-mp="1jolbo81qg98s" />} onClick={openCalendlyPopup} data-id="element-104" data-mp="3itwks3wrikkn">
            Jetzt kostenloses Gespräch buchen
          </Button>

          <p className="mt-6 text-sm text-[#64748B]" data-id="element-106" data-mp="1sgwzrn9djkll">
            Limitiert auf 5 Gespräche pro Woche für maximale Qualität.
          </p>
        </div>
      </div>
    </section>;
}